const getSignatureDate = ({ signatureDate, value, slice }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  if (signatureDate) {
    return slice !== undefined ? signatureDate.slice(slice[0], slice[1]) : signatureDate;
  } else {
    return '';
  }
};

export default getSignatureDate;



// WEBPACK FOOTER //
// ./src/utils/print/getSignatureDate.js